export let documentVaultProps = {
    key: 0,
    image_path: '/assets/company-logo.png',
    image_description: '',
    reminder_date: new Date()
}

export let observationProps = {
    key: 0,
    entry_date: new Date().getFullYear()+'/'+(new Date().getMonth()+1)+'/'+(new Date().getDate()+1),
    logs: '',
    client: true
}

export let dayScheduleProps = {
    key: 0,
    notes: '',
    time_of_action: '',
    minutes: 0
}
export let centerPersonListProps = {
    key: 0,
    name: '',
    dob: new Date(),
    age: 0
}

//////////////////////

export let employeeProps = {
    key: 0,
    employee_id: 0,
    designation_id: 0,
    service_cost: 0,
    adjustment: 0,
    final_cost: 0
}

export const serviceOptionProps = {
    key: 0,
    option_name: '',
    cost: 0,
    adjustment: 0,
    final_cost: 0
}

export const serviceProps = {
    key: 0,
    service: {id: 0, service_title: '', sales_price: 0, profit_percent: 0, original_service_options: [], selected_service_options: [], service_providers: []},
    service_provider_id: 0,
    notify: false    
}

export const consumableProps = {
    key: 0,
    product_id: 0,
    total_qty: 0,
    cost_per_unit: 0,
    adjustment: 0,
    final_cost: 0,
    total_cost: 0
}

export const expensesProps = {
    key: 0,
    description: '',
    cost_per_unit: 0,
    qty: 0,
    total_cost: 0
}

//////////////////////

export let default_list_prop = {
    key: 0,
    billing_description: '',
    qty: 1,
    unit_price: 0,
    current_price: 0,
    adjustment: 0,
    final_unit_price: 0,
    amount: 0,
    editable: false,
}

export let extraBillingProps = {
    key: 0,
    billing_description: '',
    qty: 1,
    unit_price: 0,
    amount: 0
}

export let paymentScheduleProps = {
    key: 0,
    id: 0,
    description: '',
    capital: 0,
    amortization: 0,
    interest: 0,
    amount: 0,
    schedule_date: new Date(),    
    cleared: false
}

export let guestFormProps = {
    id: 0,
    profile_photo: '',
    guest_name: '',
    mobile_prefix: '+54',
    mobile_number: '',
    age: '',
    minor: false,
    relation: '',
    gender: 'Masculino',
    table_number_id: 0,
    invitation_status: true, // no response, accepted, rejected
    invitation_confirmation: 0,
    notes: '',
    parent_guest_id: 0,
    allowed_plus_ones: 0,
    is_parent_guest: false,
    plus_one_list: []
}

////// final
export let basicProps = {
    id: 0,
    client: {id: '', name: '', mobile_number: '', email: ''},
    center_person: '',
    center_person_dob: new Date(),
    center_person_age: 0,
    budget: {id: 0, budget_number: '', budget_date: new Date()},
    consultant: {id: 0, name: ''},
    event: {id: 0, name: '', start_at: '', end_at: '', duration: '', event_date: new Date(), fall_back_event_date: new Date(), reservation_date: new Date()},
    salon: {id: 0, name: '', cost: 0, max_round_tables: 0},
    menu: {id: 0, name: '', cost: 0},
    total_bill: 0,
    total_paid: 0,
    total_balance: 0,
    records: {
        observations: [JSON.parse(JSON.stringify(observationProps))],
        day_schedule: [JSON.parse(JSON.stringify(dayScheduleProps))],  
        documents: [JSON.parse(JSON.stringify(documentVaultProps))],     
        budgets: []
    },
    services_and_products: {
        employees: [JSON.parse(JSON.stringify(employeeProps))],
        services: [JSON.parse(JSON.stringify(serviceProps))],
        consumables: [JSON.parse(JSON.stringify(consumableProps))],
        expenses: [JSON.parse(JSON.stringify(expensesProps))],
    },
    billing_details: {
        payment_plan: 0, //manual, short term, french method
        interest_rate: 0, // interest per day
        default_discount: {amount: 0, notes: ''},
        default_billing: [JSON.parse(JSON.stringify(default_list_prop))],
        extra_billing: [JSON.parse(JSON.stringify(extraBillingProps))],
        payment_schedule: [JSON.parse(JSON.stringify(paymentScheduleProps))],
        payment_history: [],
        provisional_receipts: [],
        age_discounts: []
    },
    guests: {
        list: [],
        plus_one_list: [],
        all_guest_list: [],
        guest_form: JSON.parse(JSON.stringify(guestFormProps)),
        stats: [],
        default_count: 0
    },
    historical_halls: null,
    historical_menus: null,
    advance_percent: '',
    advance_due_days: '',
    additional_clause: '',
    email_client: false,
    email_supplier: false,
    email_employee: false,
    rescheduled: false,
    sign_percentage: 0,
    canceled: false,
    catering: {
        selected_menu_id: 0,
        food_menu_details: [],
        orders: []
    },
    client_selection_food_menu_allowed: 0,
    whatsapp_api_key: '',
    table_cloth_id: 0,
    cake_id: 0,
    media_file_list: [],
    center_person_list: [],
    disable_day_scheduling: false,
    disable_catering_edit: false,
    disable_table_plan_edit: false,
    disable_guest_addition: false,
    disable_table_cloth_selection: false,
    disable_cake_selection: false,
    terms_link: '',
    help_link: ''
}




// WEBPACK FOOTER //
// ./src/store/modules/events/properties.js